import type { JournalListQuery } from '@/api/handlers/resources/journal/requests';

/**
 * TanStack Query keys for the Journal resource. Shared so the save/post/reverse
 * mutations and the list/entry queries invalidate in step. `lists()` is the
 * prefix that covers every paged/filtered list; `list(query)` is one page.
 */
export const JournalQueryKeys = {
    all: ['journal'] as const,
    lists: () => [...JournalQueryKeys.all, 'list'] as const,
    list: (query: JournalListQuery) =>
        [...JournalQueryKeys.lists(), query] as const,
    entry: (id: string) => [...JournalQueryKeys.all, 'entry', id] as const,
};
